import './App.css';

import MainContainer from './main/components/main.container';
import { ApolloProvider } from '@apollo/client';
import { ApolloClient, InMemoryCache } from '@apollo/client';

// Router関連
import { BrowserRouter as Router, Switch } from 'react-router-dom';
import { Route } from 'react-router-dom';
// import { IContentsContent } from "./index";

function App() {
    const client = new ApolloClient({
        uri: import.meta.env.VITE_GRAPHQL_URL,
        cache: new InMemoryCache(),
    });

    return (
        <>
            <Router>
                <Switch>
                    <Route>
                        <ApolloProvider client={client}>
                            <MainContainer />
                        </ApolloProvider>
                    </Route>
                </Switch>
            </Router>
        </>
    );
}

export default App;
